import { render, staticRenderFns } from "./DocumentSearchFilter.vue?vue&type=template&id=77b904f8&"
import script from "./DocumentSearchFilter.vue?vue&type=script&lang=ts&"
export * from "./DocumentSearchFilter.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentSearchFilter.vue?vue&type=style&index=0&id=77b904f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports